module.exports = __webpack_public_path__ + "static/media/Disconnect.1189ed25.svg";